import { motion, useInView } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';

function useCountUp(target, inView, duration = 1600) {
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const start = performance.now();
    let raf;
    const tick = (t) => {
      const p = Math.min(1, (t - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      setVal(Math.round(target * eased));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [target, inView, duration]);
  return val;
}

function Stat({ prefix = '', suffix = '', value, label, sub }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-60px' });
  const n = useCountUp(value, inView);
  return (
    <div ref={ref} className="relative">
      <div className="font-poppins font-black text-white text-5xl md:text-6xl lg:text-7xl leading-none tracking-[-0.03em] tabular-nums">
        <span className="text-[#FFD400]">{prefix}</span>{n.toLocaleString()}<span className="text-[#39A8FF]">{suffix}</span>
      </div>
      <div className="mt-4 font-inter font-semibold uppercase tracking-[0.22em] text-[12px] text-white/85">{label}</div>
      {sub && <div className="mt-2 font-inter text-white/50 text-sm">{sub}</div>}
    </div>
  );
}

export default function StatsBand() {
  return (
    <section data-testid="stats-band" className="relative py-24 md:py-32 border-t border-white/5">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-y-14 gap-x-6 md:gap-x-10">
          <Stat value={3} suffix=" min" label="Free Assessment" sub="From first click to submission" />
          <Stat value={9} suffix="/9" label="Provinces Covered" sub="Nationwide enquiry intake" />
          <Stat value={3} suffix=" yrs" label="Standard Prescription" sub="Per the Prescription Act 68/1969" />
          <Stat value={24} suffix="/7" label="WhatsApp Enquiries" sub="Reviewed within business hours" />
        </div>
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-16 max-w-3xl font-inter text-white/55 text-sm md:text-base"
        >
          Figures reflect our intake framework, not case outcomes. Each matter is reviewed on its own facts and law. See our Disclaimer.
        </motion.p>
      </div>
    </section>
  );
}
